import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { bookingFormCommon } from "./c005-bookingform-common";

require('parsley');

export class qwikcilverForm {
	private formEl:any = $('#qwikcilver-form');
	
	private $loginError:Array<string> = [];
	$validationSuccess    : any = true;

	$scope: any = $('#qwikcilver-form');
	private contactBase:any = new contactForm();$error:Array<any>;
	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"]');

		_self.contactBase.initFormTextInputs(inputElArr);
	}
   
	validateForm(): any {
		let _self = this;
		let nameInputs:any = $('#search-panel--firstName, #search-panel--lastName');
		nameInputs.each((i:number, el:any) => {
			$(el).attr('data-parsley-pattern', '^[a-zA-Z ]+$');
		});

		// ticket number: integer only
		let ticketNumberInputs:any = $('#search-panel--ticketNumber');
		ticketNumberInputs.attr({
			'data-parsley-type': 'integer',
			'max-length': '13',
			'minlength': '13'
		});
		// ticket number accepts 13 digits only with prefill
		let ticketNumberDigits:any = $('#search-panel--ticketNumber');
		ticketNumberDigits.keypress(function(){
			var prefix = '232';
			if(this.value.indexOf(prefix)!==0){
				this.value = prefix + this.value;
			}
			if (ticketNumberDigits.value == ''){
				prefix + this.tickerNumberDigits;
		   }else{
			   prefix + this.tickerNumberDigits
		   }
		});
		
		_self.contactBase.validateForm(_self.formEl, function(validation: any) {
			// all your custom validation here
		},
		function(validation:any, formData:any){
			var url = _self.formEl.attr("action");
		// success fuctions here
		let htmlFormData:any = new FormData(validation.$element[0]);
		let populateurl;
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			 populateurl = '/dummy-data/addtraveller.json';
		}
		else {
		   populateurl = '/bin/services/new/qwikcilverSearch';
		}
		let bcommon: any = new bookingFormCommon();
		$.ajax({
			type: 'POST',
			url: populateurl,
			data: htmlFormData,
			success: function(msg:any) {
			let json:any=null;
			if(typeof msg==='string'){
			json = JSON.parse(msg);
			}else{
			json=msg;
			}
			var responseCode = json.code;
			if(responseCode=="GS"){
			$('.qwikcilver-submission--success').removeClass('hide');
			$('.qwikcilver-submission--error').addClass('hide');
			}
			else{
			$('.qwikcilver-submission--success').addClass('hide');	
			$('.qwikcilver-submission--error').removeClass('hide')
			}
			bcommon.preloaderClose();
			},error: function(error:any) {
			$('.qwikcilverForm').show();
			$('.qwikcilver-submission--success').addClass('hide');
			$('.qwikcilver-submission--error').addClass('hide');
			bcommon.preloaderClose();
				},
			cache: false,
			contentType: false,
			processData: false,
		})		
	});
	}

	partnerForm(): any {
		let _self = this;
		_self.$scope.find('#qwikcilver-form-submit').click((evt: any) => {
         
			var nav = $('.qwikcilverForm');
			if (nav.length) {
				var contentNav = nav.offset().top;
	             }
				 $('html, body').animate({ scrollTop: '100px' });
		});
	}
}

let scope:Element = document.querySelector('#qwikcilver-form');
if (scope){
	try {
	let partnerform = new qwikcilverForm();
		$('.form-about--success').show();
		partnerform.initTextInputs();	
		partnerform.validateForm();
        partnerform.partnerForm();
		
	} catch(e) {console.error(e);}
}